import React, { Fragment, useState } from "react";
import { Card, Col, CardBody } from "reactstrap";
import HeaderCard from "../../Common/HeaderCard";
import { GoogleMap, InfoWindow, useJsApiLoader } from "@react-google-maps/api";
import { ContainerStyle, DefaultCenter } from "../../../Data/Map/GoogleMap";

const BasicMarker = () => {
  const [location] = useState({
    address: false,
    mapPosition: { lat: 18.5204, lng: 73.8567 },
    markerPosition: { lat: 18.5204, lng: 73.8567 },
  });
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "https://maps.googleapis.com/maps/api/js?key=AIzaSyAjeJEPREBQFvAIqDSZliF0WjQrCld-Mh0",
  });
  return (
    <Fragment>
      <Col xl="6" md="12">
        <Card>
          <HeaderCard title={"Basic MarkerMap"} />
          <CardBody>
            <div className="react-simple-map-container">
              {isLoaded ? (
                <GoogleMap mapContainerStyle={ContainerStyle} center={DefaultCenter} zoom={10}>
                  {location.address ? (
                    <InfoWindow position={{ lat: location.markerPosition.lat + 0.0018, lng: location.markerPosition.lng }}>
                      <div>
                        <span style={{ padding: 0, margin: 0 }}>{"Current Location"}</span>
                      </div>
                    </InfoWindow>
                  ) : (
                    ""
                  )}
                </GoogleMap>
              ) : (
                ""
              )}
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default BasicMarker;
